// extracted by mini-css-extract-plugin
module.exports = {"content":"videoModal_content__2rUEv","dialog":"videoModal_dialog__2LIpj"};